import React, { Component } from 'react';

import { DynamicFormDialog } from '../common/components/DynamicFormDialog';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { Helper } from '../common/helpers/Helper';

export class DeviceNetworkInfoDialog extends Component {
  getFormDefinition() {
    const formDefinition = JSON.parse(JSON.stringify(this.props.fieldDefNetworkInfo || {}));
    if (!formDefinition.steps || !formDefinition.steps[0] || !formDefinition.steps[0].fields) return {};

    formDefinition.dialogHeading = Helper.getString('networkInfo');
    formDefinition.formType = 'edit';
    formDefinition.ctaButtonText = 'Save';
    const currentValues = this.props.current && this.props.current.networkInfo ? this.props.current.networkInfo : {};
    Helper.populateFormDefinitionValues(formDefinition, currentValues);
    return formDefinition;
  }

  handleCustomSubmit = ({ formData, caller }) => {
    const powerVoltage = Number(formData.powerVoltage);
    const powerCurrent = Number(formData.powerCurrent);

    if (Number.isNaN(powerVoltage) || Number.isNaN(powerCurrent)) {
      const errorMessage = 'Power Voltage and Power Current must be valid decimal numbers';
      caller.setState({
        fetchState: ApiHelper.State.ERROR,
        errMsg: errorMessage,
        success: false,
        message: errorMessage,
        inProcess: false
      });
      return;
    }

    ApiHelper.call({
      method: 'PUT',
      endPoint: ApiHelper.makeUrlPath(['devices', this.props.current.id]),
      jsonBody: {
        networkInfo: {
          username: formData.username,
          password: formData.password,
          networkType: formData.networkType,
          powerVoltage,
          powerCurrent,
        }
      }
    }, (err) => {
      if (err) {
        const errorMessage = Helper.getErrorMsg(err);
        caller.setState({
          fetchState: ApiHelper.State.ERROR,
          errMsg: errorMessage,
          success: false,
          message: errorMessage,
          inProcess: false
        });
        return;
      }

      caller.setState({
        success: true,
        message: Helper.getString('successful'),
        inProcess: false
      });
      if (this.props.onCompleteAction) this.props.onCompleteAction();
    });
  }

  render() {
    if (!this.props.current || !this.props.fieldDefNetworkInfo) return null;

    return (
      <DynamicFormDialog
        customSubmit={this.handleCustomSubmit}
        formDefinition={this.getFormDefinition()}
        isOpen={this.props.isOpen}
        onClosed={this.props.onClosed}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/DeviceNetworkInfoDialog.js